"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Hashtag = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        fillRule: "evenodd",
        d: "m15.067 7.968.97-3.467 2.205.001-.97 3.466H19.5l-.613 2.202h-2.232l-1.025 3.66h2.222l-.614 2.203h-2.224l-.97 3.467-2.205-.001.97-3.466H8.933l-.97 3.466-2.205-.001.97-3.465H4.5l.613-2.202h2.232l1.025-3.66H6.126l.613-2.203h2.247L9.957 4.5l2.204.001-.97 3.467h3.876Zm-.617 2.202h-3.876L9.55 13.83h3.876l1.024-3.66Z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Hashtag;
